export default __webpack_public_path__ + "static/media/meclogo.8d70dcf7.png";